import { SET_RESTAURANT_PRICINGS } from "../restaurant/constants";

const initState = [];

export default function restaurantPricingReducer(state = initState, action) {
  switch (action.type) {
    case SET_RESTAURANT_PRICINGS:

      return action.payload;

    default:
      return state;
  }
}
